<template>
<div> 
 
<div class="contentContainerHome1">
  <div class="content">
    <br><h1>智造云 ERP 系统</h1>
    <p class="textMiddle" style="line-height:1.5;">多个应用模块、客户、项目、采购、库存、生产、人事、财务等全面管理  更有 超级流程引擎和专属手机 App，为您打造全业务覆盖、全流程驱动的云办公ERP系统</p>
    <br><!--a class="button2 textBig" style="border:1px solid white;text-align:center;width:150px;" href="/demo">立即体验和试用</a-->
  </div>
</div>

 

<div class="contentContainer">
  <div class="content" align="center">
    <br><h2>Plus应用模块，全面协同办公</h2>
    <div class="textGray textBig">—— 更有 <a class="textGray" href="javascript:;">DELPHI DATASNAP低代码开发平台</a>，为您量身定制 ERP 系统</div><br>
    <div class="block2" style="padding-right:0px;">
      <a href="function.html"><img class="contentImage" alt="ERP功能模块1" src="/static/picture/function1.png" border="0"></a>
    </div><div class="block2" style="padding-left:0px;">
      <a href="function.html"><img class="contentImage" alt="ERP功能模块2" src="/static/picture/function2.png" border="0"></a>
    </div>
  </div>
</div>

<div class="contentContainer2">
  <div class="content" align="center">
    <br><h2>电子流程，全自动规范运作</h2>
    <div class="textGray textBig">—— 强劲的 <a class="textGray" href="javascript:;"> 业务流程管理</a>，大幅超越传统的 ERP 系统</div>
    <div class="block2">
      <br><a href="demo.html#demoFlow"><img class="contentImage" alt="ERP电子流程" src="/static/picture/workflow.png" border="0"></a>
    </div><div class="block2">
      <br><h3><a href="demo.html#demoFlow1" class="textBlack">全面流程化驱动</a></h3>出差、报销、请假、订单等等，超过智造云0种业务流程<br>
      <br><h3><a href="demo.html#demoFlow2" class="textBlack">电子单据全自动流转</a></h3>衔接多个办公环节和处理步骤，多人多岗无缝协作<br>
      <br><h3><a href="demo.html#demoFlow3" class="textBlack">主动通知和提醒</a></h3>流程运转到哪一步，主动给予桌面通知和App提醒<br>
      <br><h3><a href="demo.html#demoFlow4" class="textBlack">辅助填单和规范运作</a></h3>辅助用户填写电子单据，按照预定的规则审批流转
    </div>
  </div>
</div>

<div class="contentContainer">
  <div class="content" align="center">
    <br><h2>24小时移动访问，管理装进口袋</h2>
    <div class="textGray textBig">—— 结合 <a class="textGray" href="javascript:;"> 智造云ERP 手机App</a>，帮助您突破时间和地域限制</div>
    <div class="block2">
      <br><h3><a href="demo.html#demoMobile1" class="textBlack">24小时在线协作</a></h3>PC、笔记本、平板、手机四屏畅通，数据实时同步<br>
      <br><h3><a href="demo.html#demoMobile2" class="textBlack">随时随地移动审批</a></h3>即时获得提醒，按需审阅业务明细，一键审批流转<br>
      <br><h3><a href="demo.html#demoMobile3" class="textBlack">一线人员手机下单</a></h3>销售和工程等一线人员，在手机上直接拍照和下单<br>
      <br><h3><a href="demo.html#demoMobile4" class="textBlack">外勤跟踪和定位</a></h3>了解外勤人员的工作动态，评估和改进工作效果
    </div><!--div class="block2">
      <br><a href="demo.html#demoMobile"><img class="contentImage" alt="ERP移动办公" src="/static/picture/mobile.png" border="0"></a>
    </div-->
  </div>
</div>

<div class="contentContainer2">
  <div class="content" align="center">
    <br><h2>N+创新设计，体验简约精致</h2>
    <div class="textGray textBig">—— DATASNAP低代码开发平台，助力新一代的 ERP 系统</div>
    <div class="block2">
      <br><a href="demo.html#demoUI"><img class="contentImage" alt="ERP界面体验" src="/static/picture/easy.png" border="0"></a>
    </div><div class="block2">
      <br><h3><a href="demo.html#demoUI1" class="textBlack">平面化、纸张式界面</a></h3>聚焦业务和工作本身，所见即所得，能够直接打印<br>
      <br><h3><a href="demo.html#demoUI2" class="textBlack">飞快的界面响应速度</a></h3>采用Delphi开发的核心引擎，系统具有更高的运行性能<br>
      <br><h3><a href="demo.html#demoUI3" class="textBlack">辅助填写业务单据</a></h3>自动初始化数据，自动计算求和<br>
      <br><h3><a href="demo.html#demoUI4" class="textBlack">单据关联和数据同步</a></h3>在不同单据之间传递数据和关联，大幅减少操作时间
    </div>
  </div>
</div>

<div class="contentContainer">
  <div class="content">
    <br><h2 align="center">智造云多年深厚积累，客户口碑更佳</h2>
    <div align="center" class="textGray textBig">—— 源自 IBM<sup>&reg;</sup>的技术团队，打造不平凡的超级 ERP 系统</div>
    <div class="block2">
      <br><img alt="ERP用户" src="/static/picture/head05.png" style="flERPt:left;width:80px;">
      <div style="margin-left:90px;">(智造云ERP) 功能不仅在多、更在于精，帮助我们多人协同办公，大家用起来很顺手”<br>—— 江苏润森管业总经理 吕总</div>
      <br><img alt="ERP用户" src="/static/picture/head07.png" style="flERPt:left;width:80px;">
      <div style="margin-left:90px;">(智造云ERP) 产品本身技术过硬，流程强大，能支撑我们的关键业务运作，是我们特别需要的”<br>—— 江苏玉人集团 张总</div>
      <br><img alt="ERP用户" src="/static/picture/head06.png" style="flERPt:left;width:80px;">
      <div style="margin-left:90px;">(智造云ERP) 流程管理既有原则性，又有灵活性。在不同岗位间，能把工作自动衔接起来”<br>—— 江苏五洲机械 李总</div>
    </div><!--div class="block2">
      <br><a href="case.html"><img class="contentImage" alt="ERP成功客户" src="/static/picture/customers1.jpg" border="0"></a>
    </div-->
  </div>
</div>
 
</div> 
</template>
<script>
export default {
  name: 'home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App1231231abcd'
    }
  }
}
</script>
 
 


// WEBPACK FOOTER //
// src/components/index.vue